export const CrmNumberCounter = (data) => {
  let allDataTwo = [];

  const allActivities = data?.map((item) => {
    const data = item?.split("x:");
    allDataTwo.push(parseInt(data[2]));
    const totalAction = allDataTwo?.reduce((acc, total) => total + acc);
    return totalAction;
  });

  return allActivities[allActivities?.length - 1];
};
